import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';

export const InlineSelect = styled(Select)({
  fontSize: 15,
  '& .MuiInputBase-input': {
    paddingBottom: 0,
  },
});
